@app.controller 'HeadController', (MetadataService, $state) ->

  @meta = MetadataService

  @is404 = ->
    $state.current.name == '404'

  this
